import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
const initialFieldValues = {
    lenderId: "00000000-0000-0000-0000-000000000000",
    companyName: "",
    contactName: "",
    email: "",
    phoneNumber: "",
    description: "",
    aacfb: "YES",
    acceptingNew: "YES",
    status: "ACTIVE",
    minimumMonthly: 0,
    minimumDeposit: 0,
    fico: 0,
    tib: 0,
    nsf: 0,
    bk: 0,
    industryRestricted: "",
    stateRestricted: "",
    isDefault: "NO"
};
export default function Lenders() {
    const [lists, setLists] = useState([]);
    const [allData, setAllData] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [companyName, setCompanyName] = useState("");
    const [status, setStatus] = useState("ALL");
    const [values, setValues] = useState(initialFieldValues);
    const [selectedIndustries, setSelectedIndustries] = useState(null);
    const [industries, setIndustries] = useState([]);
    const [selectedStates, setSelectedStates] = useState(null);
    const [states, setStates] = useState([]);
    const [recordForEdit, setRecordForEdit] = useState(null);
    const [errors, setErrors] = useState({});
    const [btnSubmit, setBtnSubmit] = useState(true);
    const [addShow, setAddShow] = useState(false);
    const handleAddClose = () => {
        setAddShow(false);
        setRecordForEdit(null);  // Clear edit record
        setValues(initialFieldValues);  // Reset form
        setSelectedIndustries(null);  // Clear selected industries
        setSelectedStates(null);  // Clear selected states
    };
    const handleAddShow = () => {
        setRecordForEdit(null);  // Clear any previous edit
        setValues(initialFieldValues);  // Reset form
        setSelectedIndustries(null);  // Clear selected industries
        setSelectedStates(null);  // Clear selected states
        setAddShow(true);
    };
    const [viewShow, setViewShow] = useState(false);
    const handleViewClose = () => setViewShow(false);
    const handleViewShow = (v) => {
        setValues(v);
        setViewShow(true);
    }
    const handleIndustryChange = (options) => {
        const values = options.map(option => option.value).join(', ');
        setSelectedIndustries(options);
        setValues((prevValues) => ({
            ...prevValues,
            industryRestricted: options.map((option) => option.value).join(", "), // Convert to string for API
        }));
    };
    const handleStateChange = (options) => {
        const values = options.map(option => option.value).join(', ');
        setSelectedStates(options);
        setValues((prevValues) => ({
            ...prevValues,
            stateRestricted: options.map((option) => option.value).join(", "), // Convert to string for API
        }));
    };
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    }
    useEffect(() => {
        if (recordForEdit !== null) {
            setValues(recordForEdit);
        }
    }, [recordForEdit]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value,
        });
    };
    const toInputUppercase = e => {
        e.target.value = ("" + e.target.value).toUpperCase();
    };
    const validate = () => {
        let temp = {};
        temp.companyName = values.companyName === "" ? false : true;
        temp.contactName = values.contactName === "" ? false : true;
        temp.phoneNumber = values.phoneNumber === "" ? false : true;
        temp.email = values.email === "" ? false : true;
        temp.minimumMonthly = values.minimumMonthly === "" ? false : true;
        temp.minimumDeposit = values.minimumDeposit === "" ? false : true;
        temp.fico = values.fico === "" ? false : true;
        temp.tib = values.tib === "" ? false : true;
        temp.nsf = values.nsf === "" ? false : true;
        temp.bk = values.bk === "" ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            setBtnSubmit(false);
            var formData = {
                "lenderId": values.lenderId,
                "companyName": values.companyName,
                "contactName": values.contactName,
                "email": values.email,
                "phoneNumber": values.phoneNumber,
                "aacfb": values.aacfb,
                "acceptingNew": values.acceptingNew,
                "status": values.status,
                "minimumMonthly": values.minimumMonthly,
                "minimumDeposit": values.minimumDeposit,
                "fico": values.fico,
                "bk": values.bk,
                "tib": values.tib,
                "nsf": values.nsf,
                "industryRestricted": values.industryRestricted,
                "stateRestricted": values.stateRestricted,
                "isDefault": values.isDefault
            }
            addOrEdit(formData);
        }
    };
    const applicationAPI = () => {
        return {
            create: (newrecord) =>
                axios.post(config.APIACTIVATEURL + config.CREATELENDER, newrecord, { ...headerconfig }),
            update: (updateRecord) =>
                axios.put(config.APIACTIVATEURL + config.UPDATELENDER, updateRecord, { ...headerconfig }),
            delete: (id) => axios.delete(config.APIACTIVATEURL + config.DELETELENDER + "/" + id, { ...headerconfig })
        };
    };
    const addOrEdit = (formData) => {
        if (formData.lenderId === "00000000-0000-0000-0000-000000000000") {
            applicationAPI()
                .create(formData)
                .then((res) => {
                    if (res.data.statusCode === 200) {
                        handleSuccess("Record Created");
                        resetForm();
                        GetData();
                        setBtnSubmit(true);
                    }
                    else {
                        handleError(res.data.data);
                        setBtnSubmit(true);
                    }
                })
                .catch(function (error) {
                    handleError("Error in saving data");
                    setBtnSubmit(true);
                });
        } else {
            applicationAPI()
                .update(formData)
                .then((res) => {
                    if (res.data.statusCode === 200) {
                        handleSuccess("Record Updated");
                        resetForm();
                        GetData();
                        setBtnSubmit(true);
                    }
                    else {
                        handleError(res.data.message);
                        setBtnSubmit(true);
                    }
                })
                .catch(function (error) {
                    handleError("Error in updating data");
                    setBtnSubmit(true);
                });
        }
    };
    const resetForm = () => {
        setValues(initialFieldValues);
        setErrors({});
        handleAddClose();

        // Clear filters
        setCompanyName("");       // clears the input
        setSearchTerm("");        // ensures the filter resets
        setStatus("ALL");   // if using status filter
    };
    const clearresetForm = () => {
        setValues(initialFieldValues);
        setErrors({});
        handleAddClose();
        setCompanyName("");
        setStatus("ALL");
    };
    const showEditDetails = (data) => {
        setRecordForEdit(data);
        setValues(data);  // Explicitly set form values
        // Handle industry restrictions
        const restrictedIndustryArray = data.industryRestricted
            ? data.industryRestricted.split(", ").map((item) => ({
                value: item,
                label: item,
            }))
            : [];
        setSelectedIndustries(restrictedIndustryArray);
        // Handle state restrictions
        const restrictedStateArray = data.stateRestricted
            ? data.stateRestricted.split(", ").map((item) => ({
                value: item,
                label: item,
            }))
            : [];
        setSelectedStates(restrictedStateArray);
        setAddShow(true);
    };
    const GetIndustries = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETALLINDUSTRY, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    var colourOptions = response.data.data;
                    const options = colourOptions.map(item => ({
                        value: item.name,
                        label: item.name
                    }));
                    setIndustries(options);
                }
            });
    };
    const GetStates = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETAllSTATE, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    var colourOptions = response.data.data;
                    const options = colourOptions.map(item => ({
                        value: item.stateName,
                        label: item.stateName
                    }));
                    setStates(options);
                }
            });
    };
    const onDelete = (e, id) => {
        if (window.confirm('Are you sure to delete this record?')) {
            axios.delete(config.APIACTIVATEURL + config.DELETELENDER + "/" + id, { ...headerconfig })
                .then((response) => {
                    if (response.data.statusCode === 200) {
                        handleSuccess(response.data.message);
                        GetData();
                    }
                    else {
                        handleError(response.data.message);
                        GetData();
                    }
                });
        }
    }
    const GetData = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETALLLENDERS, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setLists(response.data.data);
                    setAllData(response.data.data);
                }
            });
    };
    const handleSearch = (e) => {
        const value = e.target.value;
        setCompanyName(value); // this is just the string being typed
        setSearchTerm(value.toLowerCase()); // used for filtering
        setShowSuggestions(true);
    };
    const handleSelect = (lenderdata) => {
        setCompanyName(lenderdata.companyName + " - " + lenderdata.contactName);
        setSearchTerm(lenderdata.companyName.toLowerCase());
        setShowSuggestions(false);
    }
    const filteredLenders = lists.filter((lender) => {
        const matchesStatus = status === 'ALL' || lender.status === status;
        const matchesSearch = lender.companyName.toLowerCase().includes(searchTerm);
        return matchesStatus && matchesSearch;
    });
    const applyErrorClass = (field) =>
        field in errors && errors[field] === false ? " form-control-danger" : "";
    useEffect(() => {
        GetIndustries();
        GetStates();
        GetData();
    }, [])
    return (
        <div id="layout-wrapper">
            <LayoutHeader></LayoutHeader>
            <LayoutSideBar></LayoutSideBar>
            <div className="body-wrapper">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0">Funders</h4>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-header border-0">
                                    <div className="row g-4 align-items-center">
                                        <div className="col-sm-5">
                                            <div className="search-box">
                                                <input type="text" autoComplete="off" className="form-control search" placeholder="Search funders..." name="companyName" onChange={handleSearch} value={companyName} />
                                                <i className="ri-search-line search-icon" />
                                                {showSuggestions && companyName && (
                                                    <ul className="locationListVideo scrollable-list" style={{ minWidth: "350px" }}>
                                                        {allData
                                                            .filter((m) => m.companyName.toLowerCase().includes(searchTerm)).map(m =>
                                                                <li className="locationListVideoItem" onClick={() => handleSelect(m)}>{m.companyName} - {m.contactName}</li>
                                                            )}
                                                    </ul>)}
                                            </div>
                                        </div>
                                        <div className="col-sm-2">
                                            <select className="form-select" onChange={(e) => setStatus(e.target.value)} value={status} name="status">
                                                <option value="ALL">All</option>
                                                <option value="ACTIVE">Active</option>
                                                <option value="INACTIVE">In-Active</option>
                                            </select>
                                        </div>
                                        <div className="col-sm-auto ms-auto">
                                            <div className="hstack gap-2">
                                                <button type="button" className="btn btn-danger" onClick={resetForm} >Clear</button>
                                                <button type="button" className="btn btn-primary add-btn" onClick={handleAddShow} ><i className="ri-add-line align-bottom me-1" /> Add Funder</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive table-card">
                                        <table className="table align-middle" id="customerTable">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Company</th>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th>Mobile</th>
                                                    <th>Status</th>
                                                    <th>IsDefault</th>
                                                    <th className="text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody className="list form-check-all">
                                                {filteredLenders.length > 0 && filteredLenders.map((v, index) =>
                                                    <tr key={v.lenderId}>
                                                        <td>{index + 1}</td>
                                                        <td>{v.companyName}</td>
                                                        <td>{v.contactName}</td>
                                                        <td>
                                                            {v.email.split(',').map((email, index) => (
                                                                <div key={index}>{email.trim()}</div>
                                                            ))}
                                                        </td>
                                                        <td>{v.phoneNumber}</td>
                                                        <td>
                                                            <span className="badge bg-success">{v.status}</span>
                                                        </td>
                                                        <td>
                                                            <span className="badge bg-success">{v.isDefault}</span>
                                                        </td>
                                                        <td>
                                                            <ul className="list-inline hstack gap-2 mb-0">
                                                                <li className="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Edit">
                                                                    <Link className="edit-item-btn" onClick={e => showEditDetails(v)}><i className="ri-pencil-fill align-bottom text-muted" /></Link>
                                                                </li>
                                                                <li className="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="View">
                                                                    <Link className="edit-item-btn" onClick={e => handleViewShow(v)}><i className="ri-eye-fill align-bottom text-muted" /></Link>
                                                                </li>
                                                                <li className="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Delete">
                                                                    <Link className="remove-item-btn" onClick={e => onDelete(e, v.lenderId)}>
                                                                        <i className="ri-delete-bin-fill align-bottom text-muted" />
                                                                    </Link>
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div> {/* .card*/}
                        </div>
                    </div>
                    <Modal
                        show={addShow}
                        onHide={handleAddClose}
                        onExited={() => {
                            setRecordForEdit(null);
                            setValues(initialFieldValues);
                            setSelectedIndustries(null);
                            setSelectedStates(null);
                        }}
                        size="lg"
                    >
                        <Modal.Header>
                            <Modal.Title>{values.lenderId === "00000000-0000-0000-0000-000000000000" ? "Add" : "Edit"} Funder</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                                <div className="row">
                                    <div className="col-lg-4 mb-3">
                                        <label htmlFor="companyName" className="form-label">Company Name</label>
                                        <input type="text" value={values.companyName} name="companyName" onChange={handleInputChange} className={"form-control" + applyErrorClass('brandName')} placeholder="Please Enter Company Name" />
                                        {errors.companyName === false ? (<div className="validationerror">Please enter company name </div>) : ('')}
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <label htmlFor="name" className="form-label">Contact Name</label>
                                        <input type="text" value={values.contactName} name="contactName" onChange={handleInputChange} className={"form-control" + applyErrorClass('contactName')} placeholder="Please Enter Contact Name" />
                                        {errors.contactName === false ? (<div className="validationerror">Please enter name </div>) : ('')}
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <label htmlFor="email" className="form-label">Emails</label>
                                        <input type="text" value={values.email} name="email" onChange={handleInputChange} className={"form-control" + applyErrorClass('email')} placeholder="Test1@gmail.com,Test2@gmail.com" />
                                        {errors.email === false ? (<div className="validationerror">Please enter email </div>) : ('')}
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <label htmlFor="mobile" className="form-label">Mobile</label>
                                        <input type="text" max={12} value={values.phoneNumber} name="phoneNumber" onChange={handleInputChange} className={"form-control" + applyErrorClass('phoneNumber')} placeholder="Please Enter Mobile" />
                                        {errors.phoneNumber === false ? (<div className="validationerror">Please enter mobile </div>) : ('')}
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <label htmlFor="status" className="form-label">AACFB?</label>
                                        <select name="aacfb" value={values.aacfb} onChange={handleInputChange} className={"form-select" + applyErrorClass('aacfb')}>
                                            <option value="YES">YES</option>
                                            <option value="NO">NO</option>
                                        </select>
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <label htmlFor="status" className="form-label">Accepting New?</label>
                                        <select name="acceptingNew" value={values.acceptingNew} onChange={handleInputChange} className={"form-select" + applyErrorClass('acceptingNew')}>
                                            <option value="YES">YES</option>
                                            <option value="NO">NO</option>
                                        </select>
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <label htmlFor="mobile" className="form-label">Minimum Monthly(USD)</label>
                                        <input type="number" value={values.minimumMonthly} name="minimumMonthly" onChange={handleInputChange} className={"form-control" + applyErrorClass('minimumMonthly')} placeholder="Please Enter Minimum Monthly" />
                                        {errors.minimumMonthly === false ? (<div className="validationerror">Please enter minimum monthly </div>) : ('')}
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <label htmlFor="mobile" className="form-label">Minimum Deposits</label>
                                        <input type="number" value={values.minimumDeposit} name="minimumDeposit" onChange={handleInputChange} className={"form-control" + applyErrorClass('minimumDeposit')} placeholder="Please Enter Minimum Deposit" />
                                        {errors.minimumDeposit === false ? (<div className="validationerror">Please enter minimum deposit </div>) : ('')}
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <label htmlFor="mobile" className="form-label">FICO</label>
                                        <input type="number" value={values.fico} name="fico" onChange={handleInputChange} className={"form-control" + applyErrorClass('fico')} placeholder="Please Enter FICO" />
                                        {errors.fico === false ? (<div className="validationerror">Please enter fico </div>) : ('')}
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <label htmlFor="mobile" className="form-label">TIB</label>
                                        <input type="number" value={values.tib} name="tib" onChange={handleInputChange} className={"form-control" + applyErrorClass('tib')} placeholder="Please Enter TIB" />
                                        {errors.tib === false ? (<div className="validationerror">Please enter tib </div>) : ('')}
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <label htmlFor="mobile" className="form-label">Non Sufficient Funds(NSF)</label>
                                        <input type="number" value={values.nsf} name="nsf" onChange={handleInputChange} className={"form-control" + applyErrorClass('nsf')} placeholder="0" />
                                        {errors.nsf === false ? (<div className="validationerror">Please enter nsf </div>) : ('')}
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <label htmlFor="mobile" className="form-label">BK</label>
                                        <input type="number" value={values.bk} name="bk" onChange={handleInputChange} className={"form-control" + applyErrorClass('nsf')} placeholder="0" />
                                        {errors.bk === false ? (<div className="validationerror">Please enter bk </div>) : ('')}
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <label htmlFor="status" className="form-label">Status</label>
                                        <select name="status" value={values.status} onChange={handleInputChange} className={"form-select" + applyErrorClass('status')}>
                                            <option value="ACTIVE">ACTIVE</option>
                                            <option value="INACTIVE">INACTIVE</option>
                                        </select>
                                    </div>
                                    <div className="col-lg-4 mb-3">
                                        <label htmlFor="isDefault" className="form-label">Is Default?</label>
                                        <select name="isDefault" value={values.isDefault} onChange={handleInputChange} className={"form-select" + applyErrorClass('isDefault')}>
                                            <option value="NO">NO</option>
                                            <option value="YES">YES</option>
                                        </select>
                                    </div>
                                    <div className="col-4">
                                        <label className="form-label">Restricted Industries</label>
                                        <Select isMulti name="restrictedIndustry" options={industries} className="basic-multi-select" classNamePrefix="select restricted industries" onChange={handleIndustryChange} value={selectedIndustries} />
                                    </div>
                                    <div className="col-4">
                                        <label className="form-label">Restricted States</label>
                                        <Select isMulti name="restrictedState" options={states} className="basic-multi-select" classNamePrefix="select restricted states" onChange={handleStateChange} value={selectedStates} />
                                    </div>
                                    <div className="col-lg-8 mb-3">
                                        <label htmlFor="mobile" className="form-label">Description</label>
                                        <textarea type="text" value={values.description} name="description" onChange={handleInputChange} className={"form-control" + applyErrorClass('description')} placeholder="Please Enter Comments..." />
                                    </div>
                                    <Modal.Footer>
                                        <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                                            {
                                                btnSubmit === true ?
                                                    <button type="submit" className="btn btn-primary">{values.lenderId === "00000000-0000-0000-0000-000000000000" ? "Submit" : "Update"}</button>
                                                    :
                                                    <button type="submit" className="btn btn-primary" disabled>Please wait...</button>
                                            }
                                            <button type="button" className="btn btn-danger" onClick={clearresetForm}>Cancel</button>
                                        </div>
                                    </Modal.Footer>
                                </div>
                            </form>
                        </Modal.Body>
                    </Modal>
                    <Modal show={viewShow} onHide={handleViewClose} size="lg">
                        <Modal.Header>
                            <Modal.Title>Funder Details</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                                <table className="table table-responsive">
                                    <tr className="col-lg-12 mb-3">
                                        <td><label htmlFor="companyName" className="form-label">Company Name : {values.companyName}</label></td>
                                    </tr>
                                    <tr className="col-lg-12 mb-3">
                                        <td><label htmlFor="name" className="form-label">Contact Name : {values.contactName}</label></td>
                                    </tr>
                                    <tr className="col-lg-12 mb-3">
                                        <td><label htmlFor="email" className="form-label">Email : {values.email}</label></td>
                                    </tr>
                                    <tr className="col-lg-12 mb-3">
                                        <td><label htmlFor="mobile" className="form-label">Phone Number : {values.phoneNumber}</label></td>
                                    </tr>
                                    <tr className="col-lg-12 mb-3">
                                        <td><label htmlFor="status" className="form-label">AACFB? : {values.aacfb}</label></td>
                                        <td><label htmlFor="status" className="form-label">Accepting New? : {values.acceptingNew}</label></td>
                                    </tr>
                                    <tr className="col-lg-12 mb-3">
                                        <td><label htmlFor="status" className="form-label">Minimum Monthly(USD) : {values.minimumMonthly}</label></td>
                                        <td><label htmlFor="status" className="form-label">Minimum Deposit(USD) : {values.minimumDeposit}</label></td>
                                    </tr>
                                    <tr className="col-lg-12 mb-3">
                                        <td><label htmlFor="status" className="form-label">FICO : {values.fico}</label></td>
                                        <td><label htmlFor="status" className="form-label">TIB : {values.tib}</label></td>
                                    </tr>
                                    <tr className="col-lg-12 mb-3">
                                        <td><label htmlFor="status" className="form-label">NSF : {values.nsf}</label></td>
                                        <td><label htmlFor="status" className="form-label">BK : {values.bk}</label></td>
                                    </tr>
                                    <tr className="col-lg-12 mb-3">
                                        <td><label htmlFor="status" className="form-label">Restricted States : {values.stateRestricted}</label></td>
                                    </tr>
                                    <tr className="col-lg-12 mb-3">
                                        <td><label htmlFor="status" className="form-label">Restricted Industry : {values.industryRestricted}</label></td>
                                    </tr>
                                    <tr className="col-lg-12 mb-3">
                                        <td><label htmlFor="mobile" className="form-label">Description : {values.description}</label></td>
                                    </tr>
                                </table>
                            </form>
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" className="btn btn-danger" onClick={handleViewClose}>Close</button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        </div>
    );
}